import { Button, LoadingButton } from '@olxbr/ds-core'
import { Checkbox } from '@olxbr/ds-web'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { EmailContainer } from '../../molecules/EmailContainer'
import useWindowSize from '../../../util/useWindowSize'
import { breakpoints } from '../../../util/medias'
import { ResponsiveModal } from '../../organisms/ResponsiveModal'
import { ErrorAlertbox } from '../../atoms/ErrorAlertbox/ErrorAlertbox'

const StyledFlex = styled.div`
  display: flex;
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  flex-direction: column;
`

const Wrapper = styled.div`
  color: red;
  div[data-ds-component='DS-Modal'] {
    div[role='dialog'] {
      padding: var(--spacing-3);
    }
  }
`

const StyledDeleteText = styled.span`
  color: var(--color-feedback-error-100);
`

const StyledButton = styled(LoadingButton)`
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    margin-bottom: var(--spacing-1);
  }
  @media screen and (min-width: ${breakpoints['mobile'] + 1}px) {
    margin-left: var(--spacing-1);
  }
`

export const ConfirmPhoneOverrideModal = ({
  onConfirm,
  closeModal,
  isOpen,
  emails,
  loading,
  showGenericError,
}) => {
  const [agreeCheck, setAgreeCheck] = useState(false)

  const { isMobile } = useWindowSize()

  return (
    <Wrapper>
      <ResponsiveModal
        isOpen={isOpen}
        closeModal={closeModal}
        renderButtons={
          <React.Fragment>
            <StyledButton
              variant="danger"
              size="medium"
              onClick={onConfirm}
              className={isMobile ? 'w-full' : undefined}
              isLoading={loading}
              disabled={loading || !agreeCheck}
            >
              Continuar e deletar anúncios
            </StyledButton>
            <StyledButton
              variant="link"
              size="medium"
              className={isMobile ? 'w-full' : undefined}
              onClick={closeModal}
              disabled={loading}
            >
              Cancelar
            </StyledButton>
          </React.Fragment>
        }
      >
        <StyledFlex>
          <span className="typo-title-small mb-3">
            Ao concluir a verificação e o desvínculo, os anúncios das contas abaixo serão{' '}
            <StyledDeleteText>deletados</StyledDeleteText>
          </span>
          {showGenericError && (
            <ErrorAlertbox showContactUs={false}>
              Não foi possível validar seu telefone.
            </ErrorAlertbox>
          )}
          {emails.map(email => (
            <EmailContainer key={email} email={email} />
          ))}
          <div className="flex mb-3 mt-3">
            <Checkbox
              onClick={e => setAgreeCheck(e.target.checked)}
              aria-label="deletar-anuncios"
              label="Concordo em deletar os anúncios"
              checked={agreeCheck}
            />
          </div>
        </StyledFlex>
      </ResponsiveModal>
    </Wrapper>
  )
}

ConfirmPhoneOverrideModal.propTypes = {
  onConfirm: PropTypes.func,
  isOpen: PropTypes.bool,
  emails: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool,
  showGenericError: PropTypes.bool,
}
